import {
  CREATE_GRADE_START,
  CREATE_GRADE_SUCCESS,
  CREATE_GRADE_FAILED
} from '../../actionTypes/index.js'

import gradeAxios from '../../../../axios/gradeCriteria'
// import gradeAxios from 'axios'
import { enqueueSnackbar } from '../../../actions/alert'
import { fetchGrades } from './fetch.js'

export const createGrade = payload => {
  return (dispatch, getState) => {
    dispatch(createGradeStart())
    gradeAxios
      .post('', payload)
      .then(response => {
        if (response.status === 200) {
          const filter = getState().gradeCriteria.filters

          dispatch(createGradeSuccess())
          dispatch(fetchGrades(filter))

          dispatch(
            enqueueSnackbar({
              message: 'Create Grade Success',
              options: { variant: 'success' }
            })
          )
        }
      })
      .catch(error => {
        console.log(error, { ...error })
        dispatch(createGradeFailed())
        dispatch(
          enqueueSnackbar({
            message: 'Create Grade Failed',
            options: { variant: 'error' }
          })
        )
      })
  }
}

const createGradeStart = () => {
  return {
    type: CREATE_GRADE_START
  }
}

const createGradeSuccess = () => {
  return {
    type: CREATE_GRADE_SUCCESS
  }
}

const createGradeFailed = () => {
  return {
    type: CREATE_GRADE_FAILED
  }
}
